import { CommonResponse } from "@gtpl/shared-models/production-management";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { AssetAssignmentService } from "./asset-assignment.service";
import { AssetAssignmentDto } from "./dto/asset-assignment.dto";
import { AssetByCode } from "./dto/asset-by-code.dto";
import { AssetByDate } from "./dto/asset-by-date.dto";
import { AssetByAssetCode } from "./dto/get-by-assetCode.dto";
import { AssetsId } from "../open-assets/dto/asset-id-req";
import { AssetServiceReq, UnitRequest } from "@gtpl/shared-models/common-models";

@ApiTags('assetAssignment')
@Controller('assetAssignment')

export class AssetAssignmentController {
    constructor(
        private service: AssetAssignmentService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createCheckIn')
    async createCheckIn(@Body() req: AssetAssignmentDto): Promise<CommonResponse> {
        try {
            return await this.service.createCheckIn(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/updateCheckOut')
    async updateCheckOut(@Body() req: AssetAssignmentDto): Promise<CommonResponse> {
        try {
            return await this.service.updateCheckOut(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    // @Post('/getAll')
    // async getAll(): Promise<CommonResponse> {
    //     try {
    //         return await this.service.getAll();
    //     } catch(error) {
    //         return this.applicationExceptionHandler.returnException(CommonResponse,error);
    //     }
    // }

    @Post('/getAllTrans')
    async getAllTrans(): Promise<CommonResponse> {
        try {
            return await this.service.getAllTrans();
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }


    @Post('/getAssetByCode')
    async getAssetByCode(@Body() req?:AssetByAssetCode): Promise<CommonResponse> {
        try {
            return await this.service.getAssetByCode(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getAllCheckIn')
    async getAllCheckIn(): Promise<CommonResponse> {
        try {
            return await this.service.getAllCheckIn();
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getByDate')
    async getByDate(@Body() req:AssetByDate): Promise<CommonResponse> {
        try {
            return await this.service.getByDate(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getTransById')
    async getTransById(@Body() req:AssetByAssetCode): Promise<CommonResponse> {
        try {
            return await this.service.getTransById(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/getReadyForAssetService')
    async getReadyForAssetService(@Body() req?:AssetServiceReq):Promise<CommonResponse> {
        try {
            return await this.service.getReadyForAssetService(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/getServiceOverdue')
    async getServiceOverdue(@Body() req?:AssetServiceReq):Promise<CommonResponse> {
        try {
            return await this.service.getServiceOverdue(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/getAssetsCodeForAssetService')
    async getAssetsCodeForAssetService(@Body()req?:AssetServiceReq):Promise<CommonResponse> {
        try {
            return await this.service.getAssetsCodeForAssetService(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/getPlantsForAssetService')
    async getPlantsForAssetService():Promise<CommonResponse> {
        try {
            return await this.service.getPlantsForAssetService();
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/getLocationsForAssetService')
    async getLocationsForAssetService(@Body() req?:AssetServiceReq):Promise<CommonResponse> {
        try {
            return await this.service.getLocationsForAssetService(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/getDataForServiceCalender')
    async getDataForServiceCalender(@Body() req : UnitRequest):Promise<CommonResponse> {
        try {
            return await this.service.getDataForServiceCalender(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/getWarrantyAndInsuranceDate')
    async getWarrantyAndInsuranceDate(@Body() req : UnitRequest):Promise<CommonResponse> {
        try {
            return await this.service.getWarrantyAndInsuranceDate(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getAssignmentTransAssetCodesDropDown')
    async getAssignmentTransAssetCodesDropDown(@Body() req?:AssetByAssetCode): Promise<CommonResponse> {
        try {
            return await this.service.getAssignmentTransAssetCodesDropDown(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/getInactiveReport')
    async getInactiveReport(@Body() req?:AssetByAssetCode): Promise<CommonResponse> {
        try {
            return await this.service.getInactiveReport(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getInactiveReportDropDown')
    async getInactiveReportDropDown(@Body() req?:AssetByAssetCode): Promise<CommonResponse> {
        try {
            return await this.service.getInactiveReportDropDown(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getMissedAssetServices')
    async getMissedAssetServices(@Body() req?:AssetServiceReq):Promise<CommonResponse> {
        try {
            return await this.service.getMissedAssetServices(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
}